import { ChangeEvent } from 'react';
import get from 'lodash/get';
import { RegisterOptions, useFormContext } from 'react-hook-form';
import { UseFormRegisterReturn } from 'react-hook-form/dist/types/form';

import { FormFieldElement } from '../../../types';

type CheckFormContextParams = {
  name: string;
  rules?: RegisterOptions;
  valid?: boolean | null;
  required?: boolean;
  defaultValue?: any;
};

export type BaseFieldProps<Val = any, Element extends FormFieldElement = HTMLInputElement> = {
  name: string;
  value?: Val;
  defaultValue?: Val;

  required?: boolean;

  onChange?: (value: Val, e: ChangeEvent<Element>) => void;
};

export const checkFormContext = ({ name, rules = {}, valid, required, defaultValue }: CheckFormContextParams) => {
  const context = useFormContext();
  let registerValues: Partial<UseFormRegisterReturn> = {};
  let validity = valid;
  let validationMessage;

  // It checks whether the field is in the form context using hook.
  if (context) {
    const errors = context.formState.errors;

    if (required) {
      rules.required = required;
    }

    // If it is inside the context, registers it and adds corresponding rules if provided
    registerValues = rules ? context.register(name, rules) : context.register(name);

    defaultValue = defaultValue || context.control._defaultValues[name];

    const validationObject = get(errors, name, null);

    validationMessage = validationObject ? validationObject.message : validationObject;

    if (validationMessage) {
      validity = false;
    }
  }

  return {
    validity,
    validationMessage,
    registerValues,
    defaultValue,
  };
};
